import { colors } from "./../globals/colors";

export const form = {
  skin: {
    base: {
      idle: {
        color: colors.Gray,
        placeHolderColor: colors.Gray,
        backgroundColor: "#f2f2f2",
        borderColor: "#f2f2f2",
        iconColor: colors.Gray,
      },
      disabled: {
        color: colors.Gray,
        placeHolderColor: colors.Black,
        backgroundColor: "#c8c8c8",
        borderColor: "#c8c8c8",
        iconColor: colors.Gray,
      },
      active: {
        color: colors.Gray,
        placeHolderColor: colors.Primary,
        backgroundColor: "#f2f2f2",
        borderColor: "#c2bfbf",
        iconColor: colors.Primary,
      },
      hover: {
        color: colors.Gray,
        placeHolderColor: colors.Black,
        backgroundColor: "#f2f2f2",
        borderColor: "#c2bfbf",
        iconColor: colors.Gray,
      },
      focus: {
        color: colors.Gray,
        placeHolderColor: colors.Primary,
        backgroundColor: "#f2f2f2",
        borderColor: "#c2bfbf",
        iconColor: colors.Primary,
      },
      error: {
        color: colors.Danger,
        placeHolderColor: colors.Danger,
        backgroundColor: "#f2f2f2",
        borderColor: colors.Danger,
        iconColor: colors.Danger,
      },
    },
  },
  size: {
    md: {
      fontSize: "16px",
      lineHeight: "19px",
      mobileFontSize: "14px",
      mobileLineHeight: "17px",
      height: "40px",
      padding: "20px",
    },
  },
};
